import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/Home";
import { MatchesPage } from "./pages/Matches";
import { MyBetsPage } from "./pages/MyBets";
import { WalletPage } from "./pages/Wallet";
import { AgentDashboardPage } from "./pages/AgentDashboard";

export function App() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/matches" element={<MatchesPage />} />
        <Route path="/my-bets" element={<MyBetsPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/agent" element={<AgentDashboardPage />} />
      </Routes>
    </div>
  );
}
